import { default as deDE } from 'locales/deDE.json';

export type TranslationKey = keyof typeof deDE;

export type TransParams = {
  weekNumber?: number;
  hours?: string;
  /** Guest form runner: "Question {current} of {total}" and the free-text counter. */
  current?: number;
  total?: number;
  remaining?: number;
  /** text_area's soft budget — guidance while typing, distinct from the hard maximum. */
  budget?: number;
  /** multi_select: how many options are chosen, and the limits or advice around that count. */
  count?: number;
  min?: number;
  max?: number;
  /** date_picker: the window's bounds, already formatted for the respondent's locale. */
  from?: string;
  to?: string;
  /** item_scale: how many of the items carry a level, against how many there are. */
  done?: number;
  /** file_upload: the allowed file types, already worded for the respondent's locale ("PDF or JPEG"). */
  types?: string;
  /** Job feed: a formatted amount of money and a formatted distance. */
  amount?: string;
  km?: string;
  /** Job feed: the name a talent gave a saved search. */
  label?: string;
  /** Interviews: a formatted clock time (hold expiry, room opening). */
  time?: string;
  /** Interviews: who the talent waits for in the call, or who left it. */
  name?: string;
  /** Interviews: the shortest proposal a talent may send, in minutes. */
  minutes?: number;
  week?: number;
  range?: string;
  days?: number;
  comment?: string;
  /** Week fit hints: the talent's figure and the job's, already formatted (hours, a day). */
  yours?: string;
  job?: string;
  /** My job: a formatted day, e.g. "Läuft seit {date}". */
  date?: string;
};

export enum AppLocale {
  en_US = 'en-US',
  de_DE = 'de-DE'
}
